let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3JNwJ")).then(() => parcelRequire('4yiYq'));